<template>
    <div class="is-flex">
        <span v-if="!showEditMode" class="tree-node-handle" :class="isTranslated ? 'has-text-info' : ''" @dblclick="enableEditMode">
            <span v-if="isTranslated" class="icon">
                <i class="fa fa-language" />
            </span>
            <span>{{ translatedNodeName }}</span>
        </span>

        <span v-if="canExtraInfoBeShown && !node.fightTime.inherited" class="extra-param-info">
            <span class="icon">
                <i class="fa fa-clock" />
            </span>
            <span>{{ formattedTime }}</span>
        </span>

        <span
            v-if="canExtraInfoBeShown && !node.disciplineType.inherited"
            :title="translate('page.category_manager.discipline')"
            class="extra-param-info"
        >
            <span class="icon">
                <i class="fas fa-layer-group" />
            </span>
            <span>
                {{ translate("discipline_packages.discipline." + node.disciplineType.name) }}
            </span>
        </span>

        <div v-if="canExtraInfoBeShown && !node.categoryGender.inherited" :title="translate('page.category_manager.gender_limit')">
            <Gender :gender="node.categoryGender.name" :only-icon="true" />
        </div>

        <CategoryAgeLimit
            v-if="canExtraInfoBeShown && !node.categoryAgeLimit.inherited"
            :age-min="node.categoryAgeLimit.ageMin"
            :age-max="node.categoryAgeLimit.ageMax"
        />
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../Common/translations";
    import timeFormatter from "../Common/timeFormatter";
    import Gender from "../Common/Gender.vue";
    import CategoryAgeLimit from "./CategoryAgeLimit.vue";
    import { ENABLE_EDIT_MODE, eventBus } from "./eventBus";
    import { useCategoriesManagerStore } from "./categoriesManagerStore";
    import type { CategoryNode } from "../Api/Categories/categories";

    const props = defineProps<{
        node: CategoryNode & { extendingNode?: boolean };
    }>();

    const store = useCategoriesManagerStore();

    const showEditMode = computed(() => {
        return store.editModeEnabled === props.node.id || props.node.extendingNode;
    });

    const canExtraInfoBeShown = computed(() => {
        return store.editModeEnabled !== props.node.id && !props.node.extendingNode;
    });

    const formattedTime = computed(() => {
        return timeFormatter.formatSecondsToMinutesAndSeconds(props.node.fightTime.time_in_seconds);
    });

    const isTranslated = computed(() => {
        return !!store.categoryTranslationKeys[props.node.name];
    });

    const translatedNodeName = computed(() => {
        return translate(store.categoryTranslationKeys[props.node.name] || props.node.name, true);
    });

    function enableEditMode() {
        eventBus.$emit(ENABLE_EDIT_MODE, props.node.id);
    }
</script>

<style scoped></style>
